// Import the reCAPTCHA service
import { recaptchaService } from '../services/recaptchaService';

// reCAPTCHA Configuration
export const RECAPTCHA_CONFIG = {
  // reCAPTCHA site key from Google reCAPTCHA console
  SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6Le7F4MrAAAAAAwSVX2YWlGmXSY7vMePRBJFy5jZ',
  
  // For development, you can use a test key
  // SITE_KEY: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI', // Test key for development
  
  // reCAPTCHA v2 settings
  SIZE: 'normal' as 'normal' | 'compact' | 'invisible',
  THEME: 'light' as 'light' | 'dark',
  TYPE: 'image' as 'image' | 'audio',
  
  // Custom styling
  STYLING: {
    container: 'recaptcha-container',
    badge: 'bottomright' as 'bottomright' | 'bottomleft' | 'inline'
  }
};

// reCAPTCHA verification function
export const verifyRecaptcha = async (token: string): Promise<boolean> => {
  try {
    const result = await recaptchaService.verifyToken(token);
    return result.success;
  } catch (error) {
    console.error('reCAPTCHA verification error:', error);
    return false;
  }
};

// reCAPTCHA error messages
export const RECAPTCHA_ERRORS = {
  MISSING_TOKEN: 'Please complete the reCAPTCHA verification',
  INVALID_TOKEN: 'reCAPTCHA verification failed. Please try again.',
  EXPIRED_TOKEN: 'reCAPTCHA token expired. Please refresh and try again.',
  NETWORK_ERROR: 'Network error during reCAPTCHA verification. Please check your connection.'
}; 